import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/system";
import BryxBox from "./BryxBox";
import BryxIcon from "./BryxIcon/BryxIcon";
import BryxToggleButton from "./BryxToggleButton/BryxToggleButton";
const BryxTBD = styled((props) => {
    const { visible, hidden, toggleIcon, toggleName, isHidden, setIsHidden } = props;
    const handleShowHidden = () => {
        setIsHidden((prev) => !prev);
        props.toggleAction();
    };
    return (_jsxs(BryxBox, { isFlex: true, smGap: true, children: [_jsx(BryxBox, { isFlex: true, smGap: true, sx: {
                    maxWidth: !isHidden ? "0%" : "100%",
                    visibility: !isHidden ? "hidden" : "visible",
                    transition: "max-width 0.2s linear" + (isHidden ? ", visibility 0s 0.1s" : ""),
                }, children: visible }), _jsx(BryxBox, { isFlex: true, children: _jsx(BryxToggleButton, { startIcon: _jsx(BryxIcon, { iconName: toggleIcon, smIconSize: true }), active: !isHidden, onClick: handleShowHidden, children: toggleName }) }), _jsx(BryxBox, { isFlex: true, smGap: true, sx: {
                    maxWidth: isHidden ? "0%" : "100%",
                    visibility: isHidden ? "hidden" : "visible",
                    transition: "max-width 0.2s linear" + (!isHidden ? ", visibility 0s 0.2s" : ""),
                }, children: hidden })] }));
})(({ theme }) => {
    return {};
});
export default BryxTBD;
